import throttle from 'lodash/throttle';
import {TweenLite} from 'gsap';

export default class TitleAnimation {
  constructor({base, box} = {}) {
    this.base = document.querySelector(base);
    this.box = document.querySelector(box);
    this.moveBox = this.moveBox.bind(this);
    this.initialize();
  }

  initialize() {
    this.base.addEventListener('mousemove', throttle(this.moveBox, 100));
  }

  moveBox(event) {
    let ax = -(window.innerWidth / 2 - event.clientX) / 40;
    let ay = (window.innerHeight / 2 - event.clientY) / 30;

    TweenLite.to(this.box, 0.3, {
      xPercent: '-50%',
      yPercent: '-50%',
      transform: `rotateY(${ax}deg) rotateX(${ay}deg)`,
    });
  }
}
